import classNames from 'classnames';

import styles from '../../styles/icons/brand-icon.module.css';

export interface BrandIconProps {
    type: BrandHandle;
    className?: string | null;
}

const BrandIcon = ({ type, className = null }: BrandIconProps) => {
    return <span className={classNames([styles.container, styles[type], className])} />;
};

export default BrandIcon;
